import { Edit, SimpleForm, type EditProps } from "react-admin";

import { ProjectTakhmeenFormFields } from "./ProjectTakhmeenFormFields";
import {
  transformProjectTakhmeenUpdate,
  type ProjectTakhmeenPreviousData,
  type ProjectTakhmeenUpdateFormData,
} from "./project-takhmeen-form-transforms";

export const ProjectTakhmeenEdit = (props: EditProps) => (
  <Edit
    {...props}
    transform={(
      data: ProjectTakhmeenUpdateFormData,
      options?: { previousData?: ProjectTakhmeenPreviousData }
    ) =>
      transformProjectTakhmeenUpdate(data, {
        previousData: {
          units: options?.previousData?.units,
          committedAmount: options?.previousData?.committedAmount,
          paidAmount: options?.previousData?.paidAmount,
        },
      })
    }
  >
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 720 }}>
      <ProjectTakhmeenFormFields mode="edit" />
    </SimpleForm>
  </Edit>
);
